import moment from 'moment';

export const NO_TIME_REMAINING = '00:00';

function padTime(time) {
    return String(time).length === 1 ? `0${time}` : time;
}

export function formatTimeRemaining(timeRemainingMs) {
    if (timeRemainingMs <= 0) {
        return NO_TIME_REMAINING;
    }

    const timeRemainingMins = moment.duration(timeRemainingMs).minutes();
    const timeRemainingSecs = moment.duration(timeRemainingMs).seconds();

    return `${padTime(timeRemainingMins)}:${padTime(timeRemainingSecs)}`;
}
